import styled from "styled-components";

export const RadioSurveyLikeFS = styled.div`
  display: inline-grid;
  grid-template-columns: (1, 1fr);
  justify-items: center;
  padding: 0.4em;

  svg {
    font-size: 35px;
  }
  input {
    transform: scale(1.3);
  }
  /* color: rgba(160,0,149,1); */
`;